import React from "react";
import { cover } from "polished";
import styled, { css } from "styled-components";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 4a1 1 0 0 1 1-1h20v2H1a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.752 3.168a1 1 0 0 1 0 1.664l-3.197 2.13A1 1 0 0 1 21 6.131V1.87a1 1 0 0 1 1.555-.832l3.197 2.13z"
  }));
};
ArrowSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "8"
};
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import getIconColor from "../../../utils/getIconColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import { labelSizes, labelTypography } from "../../atoms/LabelAtm/LabelAtm.config";
import Link from "../../quarks/Link";
var containerHorizontalGutterSpaceOnMedium = 2;
export var labelMarginBottomSpace = 1;
export var Arrow = styled(ArrowSvg).withConfig({
  componentId: "sc-1olk3fa-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["fill:", ";"], getIconColor(theme, $onColor));
});
export var ProductLinkMolContainer = styled.div.withConfig({
  componentId: "sc-1olk3fa-1"
})(function (_ref2) {
  var $hasSiblingWithLabel = _ref2.$hasSiblingWithLabel,
    $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  var labelVerticalPaddingSpace;
  if (typeof labelSizes.small.paddingSpace !== "number") {
    labelVerticalPaddingSpace = labelSizes.small.paddingSpace.y;
  }
  var labelAtmLineHeightSpace = theme.typography[labelTypography].lineHeightSpace;
  return css(["", ";display:flex;position:relative;", "{", ";}", "{align-items:center;justify-content:space-between;padding:", " 0;border-bottom:", " solid ", ";}", "{flex-direction:column;padding:", " ", ";border-radius:", ";", " ", "{margin-top:auto;}}&:hover{", "{fill:", ";}", "{box-shadow:", ";}}"], transition("box-shadow"), Arrow, transition("fill"), breakpoint("small", "medium"), space(4), unit(1), getBorderColor(theme, $onColor, "low"), breakpoint("medium"), space(containerHorizontalGutterSpaceOnMedium), space(4), getBorderRadius(theme, "medium"), $hasSiblingWithLabel && labelVerticalPaddingSpace && css(["margin-top:", ";"], space(labelMarginBottomSpace + labelAtmLineHeightSpace + 2 * labelVerticalPaddingSpace)), Arrow, Arrow, getColor(theme, "primary"), breakpoint("medium"), getBoxShadow(theme, "small"));
});
export var TitleLink = styled(Link).withConfig({
  componentId: "sc-1olk3fa-2"
})(["display:inline-block;margin-bottom:", ";text-decoration:none;&::after{", ";content:\"\";}"], space(1), cover());